import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index.vue"),
    meta: {
      title: "健康问诊",
    },
  },
  {
    path: "/information",
    name: "information",
    component: () => import("@/pages/information"),
    meta: {
      title: "个人信息",
    },
  },
  {
    path: "/questionnaire",
    name: "questionnaire",
    component: () => import("@/pages/questionnaire"),
    meta: {
      title: "填写问卷",
    },
  },
  {
    path: "/questionnaire2",
    name: "questionnaire2",
    component: () => import("@/pages/questionnaire/index2.vue"),
    meta: {
      title: "填写问卷",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/questionType",
    name: "QuestionType",
    component: () => import("@/pages/questionType"),
    meta: {
      title: "健康问卷",
    },
  },
  {
    path: "/transfer",
    name: "transfer",
    component: () => import("@/pages/transfer"),
    meta: {
      title: "加载中...",
    },
  }
];
const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
});
// 4. 你还可以监听路由拦截，比如权限验证。
router.beforeEach((to, from, next) => {
  if (to.matched.length == 0) return next({ path: "/404" });
  //2020.06.03增加路由切换时加载提示
  document.title = to.meta.title;
  next();
});
router.afterEach((to, from) => {});
router.onError((error) => {
  // const targetPath = router.currentRoute.value.matched;
  try {
    if (process.env.NODE_ENV == "development") {
    }
    localStorage.setItem("route_error", error.message);
  } catch (e) {}
  console.error("router.onError", error.message);
  // window.location.href = '/'
});
export default router;
